// ============================================================
// Layout tokens
//
// Geometry only. Every colour lives in theme.ts and is reached
// through theme.palette - see the colour rule in CLAUDE.md.
// ============================================================

/** Expanded sidebar width. */
export const DRAWER_WIDTH = 272;

/** Collapsed sidebar rail width - fits a 40px icon target plus gutters. */
export const DRAWER_WIDTH_MINI = 76;

/** Top app bar height; the sidebar brand block matches it so the two align. */
export const APPBAR_HEIGHT = 64;

/** Horizontal padding inside sidebar sections. */
export const SIDEBAR_GUTTER = 12;

/** Height of a primary sidebar row. */
export const NAV_ITEM_HEIGHT = 40;

/** Height of a nested sidebar row. */
export const NAV_SUBITEM_HEIGHT = 34;

/** Main content padding, as spacing units. */
export const CONTENT_PADDING = { xs: 2, sm: 3 };

// Z-Index Scale
export const Z_INDEX = {
  drawer: 1200,
  appBar: 1300,
  modal: 1400,
  snackbar: 1500,
  tooltip: 1600,
};

// Motion
export const ANIMATIONS = {
  fast: "120ms cubic-bezier(0.4, 0, 0.2, 1)",
  normal: "200ms cubic-bezier(0.4, 0, 0.2, 1)",
  slow: "320ms cubic-bezier(0.4, 0, 0.2, 1)",
  spring: "220ms cubic-bezier(0.32, 0.72, 0, 1)",
};

/** Build a transition string on the shared easing curve. */
export const createTransition = (property = "all", duration = "200ms") =>
  `${property} ${duration} cubic-bezier(0.4, 0, 0.2, 1)`;
